import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import WhatWeDo from "@/pages/WhatWeDo";
import Government from "@/pages/Government";
import Political from "@/pages/Political";
import Digital from "@/pages/Digital";
import Impact from "@/pages/Impact";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import Reports from "@/pages/Reports";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ServiceDetail from "@/pages/ServiceDetail";
import PartnerWithUs from "@/pages/PartnerWithUs";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/what-we-do" element={<WhatWeDo />} />
              <Route path="/government" element={<Government />} />
              <Route path="/political" element={<Political />} />
              <Route path="/digital" element={<Digital />} />
              <Route path="/impact" element={<Impact />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/partner" element={<PartnerWithUs />} />
              <Route path="/insights" element={<Insights />} />
              <Route path="/insights/:slug" element={<InsightDetail />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route path="/govx-admin/login" element={<AdminLogin />} />
            <Route path="/govx-admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
